import Link from 'next/link'
import { StatusBadge } from '@/components/status-badge'
import { getDashboardSummary, getRuntimeSettings, listSubscriptionRequests } from '@/lib/admin-data'
import { formatCurrencyFcfa, formatDateTime } from '@/lib/utils'

export const dynamic = 'force-dynamic'

export default async function DashboardPage() {
  const [summary, recent, runtime] = await Promise.all([
    getDashboardSummary(),
    listSubscriptionRequests({ status: 'pending', page: 1, pageSize: 8 }),
    getRuntimeSettings(),
  ])

  return (
    <div className="container-stack">
      <div className="topbar">
        <div>
          <h1>Vue d’ensemble</h1>
          <p>Suivi rapide des demandes d’abonnement et de l’état des boutiques.</p>
        </div>
      </div>

      <section className="cards-grid">
        <article className="card metric">
          <span className="metric-label">Demandes en attente</span>
          <span className="metric-value">{summary.pendingRequests}</span>
          <span className="metric-subtle">À traiter en priorité</span>
        </article>
        <article className="card metric">
          <span className="metric-label">Demandes approuvées</span>
          <span className="metric-value">{summary.approvedRequests}</span>
          <span className="metric-subtle">Historique global</span>
        </article>
        <article className="card metric">
          <span className="metric-label">Boutiques actives</span>
          <span className="metric-value">{summary.activeShops}</span>
          <span className="metric-subtle">Entitlement effectif actif</span>
        </article>
        <article className="card metric">
          <span className="metric-label">Inactives / expirées</span>
          <span className="metric-value">{summary.inactiveOrExpiredShops}</span>
          <span className="metric-subtle">À surveiller</span>
        </article>
      </section>

      <section className="page-grid">
        <article className="card">
          <div className="topbar">
            <div>
              <h2>Demandes en attente</h2>
              <p>Les 8 demandes les plus récentes.</p>
            </div>
            <Link href="/dashboard/subscription-requests" className="btn-secondary btn-small">
              Voir tout
            </Link>
          </div>

          <div className="table-wrap">
            <table className="table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Boutique</th>
                  <th>Montant</th>
                  <th>Méthode</th>
                  <th>Date</th>
                  <th>Statut</th>
                </tr>
              </thead>
              <tbody>
                {recent.rows.map((row) => (
                  <tr key={row.id}>
                    <td>#{row.id}</td>
                    <td>
                      <strong>{row.shop_name}</strong>
                      <span className="muted">{row.payer_phone || row.shop_phone || '—'}</span>
                    </td>
                    <td>{formatCurrencyFcfa(row.amount_fcfa)}</td>
                    <td>{row.method}</td>
                    <td>{formatDateTime(row.created_at)}</td>
                    <td>
                      <StatusBadge value={row.status} />
                    </td>
                  </tr>
                ))}
                {recent.rows.length === 0 ? (
                  <tr>
                    <td colSpan={6} className="muted">
                      Aucune demande en attente.
                    </td>
                  </tr>
                ) : null}
              </tbody>
            </table>
          </div>
        </article>

        <article className="card container-stack">
          <div>
            <h2>Configuration active</h2>
            <p className="muted">Valeurs globales actuellement prévues pour l’abonnement et le support.</p>
          </div>

          <div className="kv">
            <div>Nom app</div><div>{runtime.app_name}</div>
            <div>Tarif mensuel</div><div>{formatCurrencyFcfa(runtime.subscription_price_fcfa)}</div>
            <div>Wave</div><div>{runtime.wave_number || '—'}</div>
            <div>Orange Money</div><div>{runtime.orange_money_number || '—'}</div>
            <div>Support tél.</div><div>{runtime.support_phone || '—'}</div>
            <div>Support WhatsApp</div><div>{runtime.support_whatsapp || '—'}</div>
          </div>

          <Link href="/dashboard/settings" className="btn-primary">
            Gérer la configuration SenKredi
          </Link>
          <Link href="/dashboard/shops" className="btn-secondary">
            Parcourir les boutiques
          </Link>

          <div className="notice">
            Les approbations, rejets et changements de configuration passent par des routes serveur sécurisées et la clé <code>service_role</code> ne sort jamais du backend.
          </div>
        </article>
      </section>
    </div>
  )
}
